// Minimal bridge around your existing prompt-ID streaming service
import { getStreamingCurriculumResponse } from './openaiService';

// optional: tiny base64->blob util (reuse anywhere)
export function base64ToBlobUrl(base64, mime = 'image/png') {
  try {
    const byteChars = atob(base64);
    const arr = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) arr[i] = byteChars.charCodeAt(i);
    return URL.createObjectURL(new Blob([arr], { type: mime }));
  } catch (e) {
    console.error('Failed to convert base64 to blob:', e);
    return null;
  }
}

/**
 * Send a streaming message via Prompt-ID Responses API
 * @param {Object} args
 *  - userMessage: string
 *  - conversationId: string|null
 *  - fileIds: string[]  (optional, for code_interpreter)
 *  - onDelta(text), onComplete(finalResp), onError(err)
 *  - onImage(imageObj)  // { kind:'base64', base64, mime, revised_prompt? }
 * @returns {Promise<void>}
 */
export async function sendStreamingViaPromptId({
  userMessage,
  conversationId = null,
  fileIds = [],
  onDelta = () => {},
  onComplete = () => {},
  onError = () => {},
  onImage = () => {},
  onStatus = () => {},
  onReasoning = () => {},
  onImageGeneration = () => {},
}) {
  return getStreamingCurriculumResponse(
    userMessage,
    {}, // context not required (your prompt handles it)
    {
      onChunk: onDelta,
      onComplete,
      onError,
      onStatus,
      onImageGenerated: onImage,
      onImageGeneration,
      onFileSearch: () => {},
      onReasoning,
    },
    conversationId,
    fileIds
  );
}
